var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHostages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1155_9843)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 8,
    r: 3,
    stroke: "#4D4D4D",
    strokeWidth: 1.67,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10,
    r: 9,
    stroke: "#4D4D4D",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17C16.1461 15.8525 15.3662 14.8384 14.2814 14.1152C13.1966 13.392 11.8674 13 10.5 13C9.1326 13 7.80341 13.392 6.71858 14.1152C5.63375 14.8384 4.85391 15.8525 4.5 17",
    stroke: "#4D4D4D",
    strokeWidth: 1.67,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1155_9843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostages);
export default __webpack_public_path__ + "static/media/hostages.a040a990ec805e70576293ebf3e7e2f2.svg";
export { ForwardRef as ReactComponent };